import React from 'react';
import styles from './BetLines.module.scss';
import HomeTeamName from './BetLine/HomeTeamName/HomeTeamName';
import DeleteBetLineButton from './BetLine/DeleteButton/DeleteButton';
import MarketName from './BetLine/MarketName/MarketName';
import LiveBadge from '../../shared/LiveBadge/LiveBadge';
import Mbn from './BetLine/Mbn/Mbn';
import ProgramCode from './BetLine/ProgramCode/ProgramCode';
import EventName from './BetLine/EventName/EventName';
import ClosedBetLine from './BetLine/ClosedBetLine/ClosedBetLine';
import Banco from './BetLine/Banco/Banco';
import OddBadge from './BetLine/OddBadge/OddBadge';
import { EVENT_TYPE_ENUM } from '../../../constants/enums';

const SystemBetLine = ({ bet }) => {
    return (
        <div className={`${styles.bet} ${styles.banco}`}>
            <ClosedBetLine bet={bet} />
            <Banco bet={bet} />
            <div className={styles.betSystemWrap}>
                <div className='flex'>
                    <HomeTeamName name={bet.outcomeName} />
                    <OddBadge bet={bet} />
                    <DeleteBetLineButton bet={bet} />
                </div>
                <div className={'m-b-2'}>
                    <MarketName name={bet.marketName} />
                    <LiveBadge isLive={bet.isLive} />
                </div>
                <Mbn mbn={bet.mbn} />
                {bet.eventType !== EVENT_TYPE_ENUM.outright && <ProgramCode programCode={bet.programCode} />}{' '}
                <EventName teams={bet.teams} eventName={bet.eventName} />
            </div>
        </div>
    );
};

export default SystemBetLine;
